export default class classVerySwitch {
  static getPropsTemplate = () => ({
    CSS: [""],
    isDisabled: false,
    isLoading: true,
    selected: false,
    onChangeSelected: (toggleSelected = false) => {},
  });
}
